import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Privacy from './components/Privacy';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import TechReact from './components/TechReact';
import TechNode from './components/TechNode';
import TechAI from './components/TechAI';
import TechCloud from './components/TechCloud';
import ProjectDetail from './components/ProjectDetail';

import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import Dashboard from './admin/Dashboard';
import ManageProjects from './admin/ManageProjects';
import ManageServices from './admin/ManageServices';
import ManageFAQs from './admin/ManageFAQs';
import ManageTechnologies from './admin/ManageTechnologies';
import ManageTestimonials from './admin/ManageTestimonials';
import ManageAbout from './admin/ManageAbout';
import ManageOwnedProducts from './admin/ManageOwnedProducts';
import ManageVisitors from './admin/ManageVisitors';
import VisitorTracker from './components/VisitorTracker';


function App() {
  return (
    <>
      <VisitorTracker />
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/services" element={<Services />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:slug" element={<ProjectDetail />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQ />} />

      {/* Tech Routes */}
      <Route path="/tech/react" element={<TechReact />} />
      <Route path="/tech/node" element={<TechNode />} />
      <Route path="/tech/ai" element={<TechAI />} />
      <Route path="/tech/cloud" element={<TechCloud />} />

      {/* Admin Panel */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="projects" element={<ManageProjects />} />
        <Route path="owned-projects" element={<ManageOwnedProducts />} />
        <Route path="services" element={<ManageServices />} />
        <Route path="faqs" element={<ManageFAQs />} />
        <Route path="technologies" element={<ManageTechnologies />} />
        <Route path="reputation" element={<ManageTestimonials />} />
        <Route path="visitors" element={<ManageVisitors />} />
        <Route path="about" element={<ManageAbout />} />

      </Route>

      {/* Fallback to Home for other routes */}
      <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

export default App;
